import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchCorpOrganizationsArgs,
  CorpOrganizationByIdArgs,
  FetchCorpMembersArgs,
} from '../api/types/corpOrganizations.types';

import {
  fetchCorpOrganizationById,
  fetchCorpOrganizations,
  fetchCorpMembers,
} from '../api/corpOrganizations.api';

export const corpOrganizationsQueryKeys = createQueryKeys('corpOrganizations', {
  byId: ({ id }: CorpOrganizationByIdArgs) => ({
    queryFn: async () => fetchCorpOrganizationById({ id }),
    queryKey: [id],
  }),
  fetchCorpOrganizations: ({ filters }: FetchCorpOrganizationsArgs) => ({
    queryFn: () => fetchCorpOrganizations({ filters }),
    queryKey: [filters],
  }),
  members: ({ corpOrganizationId, filters }: FetchCorpMembersArgs) => ({
    queryFn: () => fetchCorpMembers({ corpOrganizationId, filters }),
    queryKey: [corpOrganizationId, filters],
  }),
});
